// eslint-disable-next-line jira/import-whitelist
import { fetchIssueDescriptionSmartlinkData } from '@jira/issue__fetch-services/src/fetchIssueDescriptionSmartlinkData.tsx';
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import type { PrefetchedSmartlinkData } from '@jira/issue__fetch-services/src/fetchORSDataSSR.tsx';
import type { ResourceStoreContext, RouterDataContext } from '@atlassian/react-resource-router';

export const getIssueDescriptionSmartlinkData = async (
	routerContext: RouterDataContext,
	storeContext: ResourceStoreContext,
): Promise<PrefetchedSmartlinkData[] | null> => {
	// force smart link fetcher to not fire on client side to prevent CORS policy issues and enable prefetching of all links should SSR resource timeout.
	if (!__SERVER__) {
		return null;
	}
	const issueKey = getIssueKey(routerContext.match);
	const { tenantContext } = storeContext;
	const cloudId = tenantContext?.cloudId;

	if (!issueKey || !cloudId) {
		return null;
	}

	try {
		return await fetchIssueDescriptionSmartlinkData(issueKey, cloudId);
	} catch (error) {
		throw createResourceError(
			{
				component:
					'spa.view.routes.issue-view.issue-description-smartlink.getIssueDescriptionSmartlinkData',
				message: 'An error was thrown while prefetching issue description smart link data',
			},
			error,
		);
	}
};
